import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'roles',
    collectionActionName: 'ADMINISTRATOR_ROLES',
    itemActionName: 'ADMINISTRATOR_ROLE',
});
